import * as React from "react";
import * as d3 from "d3";

export interface LineRuleProps {
  title: string;
  width: number;
  value: number;
  domain: [number, number];
}

export const LineRule = ({ title, width, value, domain }: LineRuleProps) => {
  const scale = d3.scale.linear().domain(domain).range([0, 100]);
  const left = scale(value) + "%";

  return (
    <div className="line-rule" style={{ width }}>
      <div className="line-rule__line" style={{ left }} />
      <div className="line-rule__title" style={{ left }}>
        {title}
      </div>
    </div>
  );
};

export default LineRule;
